<template>
  <div class="homepage">
    <el-row :gutter="15">
      <el-col :md="12" :lg="9">
        <data-list class="mb-20" style="height: 96px"/>
      </el-col>
      <el-col :md="12" :lg="9">
        <navigation-card class="mb-20" style="height: 96px"/>
      </el-col>
      <el-col :md="24" :lg="6">
        <plat-notice class="mb-20" style="height: 96px"/>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col v-permission="['view_orders']" class="mb-20" :lg="12">
        <order-list />
      </el-col>
      <el-col v-permission="['view_goods']" class="mb-20" :lg="12">
        <hot-product />
      </el-col>
    </el-row>

    <!-- 数据报表区 -->
    <div class="data_chart" v-if="false">
      <div class="info_title">
        <div class="color-black welfare_title">销售金额</div>
        <div class="search_range">
          <el-select v-model="amountRange" size="mini" placeholder="选择时间">
            <el-option label="最近一周" value="1"></el-option>
            <el-option label="最近一个月" value="2"></el-option>
            <el-option label="最近半年" value="3"></el-option>
            <el-option label="最近一年" value="4"></el-option>
          </el-select>
        </div>
      </div>
      <sale-amount class="mt-10 echart_card" :range="amountRange"/>
    </div>

    <div class="data_chart" v-if="false">
      <div class="info_title">
        <div class="color-black welfare_title">销售数量</div>
        <div class="search_range">
          <el-select v-model="countRange" size="mini" placeholder="选择时间">
            <el-option label="最近一周" value="1"></el-option>
            <el-option label="最近一个月" value="2"></el-option>
            <el-option label="最近半年" value="3"></el-option>
            <el-option label="最近一年" value="4"></el-option>
          </el-select>
        </div>
      </div>
      <sale-total class="mt-10 echart_card" :range="countRange"/>
    </div>
  </div>
</template>

<script>
  import DataList from './components/DataList.vue';
  import PlatNotice from './components/PlatNotice.vue';
  import NavigationCard from './components/NavigationCard.vue';
  import HotProduct from './components/HotProduct.vue';
  import SaleAmount from './components/SaleAmount.vue';
  import SaleTotal from './components/SaleTotal.vue';
  import OrderList from './components/OrderList';

  export default {
    name: 'layout',
    components: {
      DataList,
      PlatNotice, 
      NavigationCard,
      HotProduct,
      SaleAmount,
      SaleTotal,
      OrderList
    },
    data() {
      return {
        amountRange: '1',
        countRange: '1'
    }
  }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/base.scss';
  .homepage{
    .emp_related{
      background-color: #fff;
      border-radius: $border-radius-lg;
      @include flexbox(row,space-between,flex-start);
    }
    .link_related{
      margin-top: 40px;
      @include flexbox(row,space-between,flex-start);
      .info_title{
        @include flexbox(row,space-between,flex-start);
      }
      .more_detail{
        font-size: 9px;
        cursor: pointer;
      }
    }
    .data_chart{
      margin-top: 40px;
      .info_title{
        @include flexbox(row,space-between,flex-start);
        .search_range{
          .el-select{
            width: 98px;
          }
        }
      }
    }
    ::v-deep .search_range .el-input__inner {
      padding-left: 8px;
      background-color: $slateGray;
      border: 1px solid #dcdfe6 !important;
    }
    ::v-deep .el-select-dropdown__item {
      font-size: 8px;
      color: $sliver !important;
    }
  }
</style>
